module.exports = __webpack_public_path__ + "img/box_pro_five_6.f0b7653d.jpg";